import { render, staticRenderFns } from "./CalculatorSidebar.vue?vue&type=template&id=6771fb7a&scoped=true"
import script from "./CalculatorSidebar.vue?vue&type=script&lang=ts"
export * from "./CalculatorSidebar.vue?vue&type=script&lang=ts"
import style0 from "./CalculatorSidebar.vue?vue&type=style&index=0&id=6771fb7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6771fb7a",
  null
  
)

export default component.exports